import React from 'react';
import PropTypes from 'prop-types';
import { useApiQuery } from '../../../../../api/hooks';
import TransactionLine from './TransactionLine';

// Переиспользуемый список транзакций (для истории команды / продаж точки).
// Лениво грузит по url и рендерит строки TransactionLine, новые сверху.
export default function FairTxList({ queryKey, url, teamName, colorOf, pointName }) {
    const { data: txs = [], isLoading, error } = useApiQuery(queryKey, url, { refetchOnMount: 'always' });

    if (isLoading) return <div className="bt-empty">Загрузка…</div>;
    if (error) return <div className="bt-empty">Не удалось загрузить транзакции</div>;
    if (txs.length === 0) return <div className="bt-empty">Транзакций нет</div>;

    const sorted = [...txs].sort((a, b) => new Date(b.created) - new Date(a.created));
    return (
        <div className="fr-txwrap">
            {sorted.map(tx => <TransactionLine key={tx.id} tx={tx} teamName={teamName} colorOf={colorOf} pointName={pointName} />)}
        </div>
    );
}

FairTxList.propTypes = {
    queryKey: PropTypes.array.isRequired,
    url: PropTypes.string.isRequired,
    teamName: PropTypes.func.isRequired,
    colorOf: PropTypes.func.isRequired,
    pointName: PropTypes.func
};

FairTxList.defaultProps = { pointName: null };
